module.exports = __webpack_public_path__ + "img/title.bfacd4f9.webp";